/* This file is based on `vscode-lean4/src/leanclient.ts` */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { EventEmitter, Range, DocumentHighlightKind } from 'vscode';
import { DidOpenTextDocumentNotification, MonacoLanguageClient as LanguageClient, CloseAction, ErrorAction, State } from 'monaco-languageclient';
import { toSocket, WebSocketMessageReader, WebSocketMessageWriter } from 'vscode-ws-jsonrpc';
import { 
// toolchainPath, lakePath, addServerEnvPaths, serverArgs, serverLoggingEnabled, serverLoggingPath, shouldAutofocusOutput,
getElaborationDelay
// lakeEnabled
 } from './config';
// import { logger } from './utils/logger'
import { SemVer } from 'semver';
// import { fileExists, isFileInFolder } from './utils/fsHelper'
import { c2pConverter, p2cConverter, patchConverters } from './utils/converters';
var escapeRegExp = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
export function getFullRange(diag) {
    return (diag === null || diag === void 0 ? void 0 : diag.fullRange) || diag.range;
}
var LeanClient = /** @class */ (function () {
    function LeanClient(socketUrl, workspaceFolder, folderUri, showRestartMessage) {
        this.socketUrl = socketUrl;
        this.showRestartMessage = showRestartMessage;
        this.running = false;
        this.subscriptions = [];
        this.noPrompt = false;
        this.showingRestartMessage = false;
        // private readonly elanDefaultToolchain: string
        this.didChangeEmitter = new EventEmitter();
        this.didChange = this.didChangeEmitter.event;
        this.diagnosticsEmitter = new EventEmitter();
        this.diagnostics = this.diagnosticsEmitter.event;
        this.didSetLanguageEmitter = new EventEmitter();
        this.didSetLanguage = this.didSetLanguageEmitter.event;
        this.didCloseEmitter = new EventEmitter();
        this.didClose = this.didCloseEmitter.event;
        this.customNotificationEmitter = new EventEmitter();
        /** Fires whenever a custom notification (i.e. one not defined in LSP) is received. */
        this.customNotification = this.customNotificationEmitter.event;
        /** saved progress info in case infoview is opened, it needs to get all of it. */
        this.progress = new Map();
        this.progressChangedEmitter = new EventEmitter();
        this.progressChanged = this.progressChangedEmitter.event;
        this.stoppedEmitter = new EventEmitter();
        this.stopped = this.stoppedEmitter.event;
        this.restartedEmitter = new EventEmitter();
        this.restarted = this.restartedEmitter.event;
        this.restartingEmitter = new EventEmitter();
        this.restarting = this.restartingEmitter.event;
        this.restartedWorkerEmitter = new EventEmitter();
        this.restartedWorker = this.restartedWorkerEmitter.event;
        this.serverFailedEmitter = new EventEmitter();
        this.serverFailed = this.serverFailedEmitter.event;
        /** Files which are open. */
        this.isOpen = new Map();
        // this.storageManager = storageManager
        // this.outputChannel = outputChannel
        this.workspaceFolder = workspaceFolder; // can be null when opening adhoc files.
        this.folderUri = folderUri;
        // this.elanDefaultToolchain = elanDefaultToolchain
        // this.subscriptions.push(workspace.onDidChangeConfiguration((e) => this.configChanged(e)))
    }
    LeanClient.prototype.dispose = function () {
        this.subscriptions.forEach(function (s) { return s.dispose(); });
        if (this.isStarted())
            void this.stop();
    };
    // async showRestartMessage (restartFile: boolean = false): Promise<void> {
    //   // if (!this.showingRestartMessage) {
    //   //   this.showingRestartMessage = true
    //   //   let restartItem: string
    //   //   let messageTitle: string
    //   //   if (!restartFile) {
    //   //     restartItem = 'Restart Lean Server'
    //   //     messageTitle = 'Lean Server has stopped unexpectedly.'
    //   //   } else {
    //   //     restartItem = 'Restart Lean Server on this file'
    //   //     messageTitle = 'The Lean Server has stopped processing this file.'
    //   //   }
    //   //   const item = await this.showErrorMessage(messageTitle, restartItem)
    //   //   this.showingRestartMessage = false
    //   //   if (item === restartItem) {
    //   //     void this.start()
    //   //     // if (restartFile && (window.activeTextEditor != null)) {
    //   //     //   await this.restartFile(window.activeTextEditor.document)
    //   //     // } else {
    //   //     //   void this.start()
    //   //     // }
    //   //   }
    //   // }
    // }
    LeanClient.prototype.restart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var startTime, clientOptions, insideRestart, error_1, starHandler;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startTime = Date.now();
                        console.log('[LeanClient] Restarting Lean Server');
                        if (!this.isStarted()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.stop()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.restartingEmitter.fire(undefined);
                        clientOptions = {
                            // use a language id as a document selector
                            documentSelector: ['lean4'],
                            initializationOptions: {
                                editDelay: getElaborationDelay(), hasWidgets: true
                            },
                            connectionOptions: {
                                maxRestartCount: 0,
                                cancellationStrategy: undefined
                            },
                            // disable the default error handler
                            errorHandler: {
                                error: function () { return ({ action: ErrorAction.Continue }); },
                                closed: function () { return ({ action: CloseAction.DoNotRestart }); }
                            },
                            middleware: {
                                handleDiagnostics: function (uri, diagnostics, next) {
                                    var e_1, _a;
                                    next(uri, diagnostics);
                                    if (_this.client == null)
                                        return;
                                    var uri_ = c2pConverter.asUri(uri);
                                    var diagnostics_ = [];
                                    try {
                                        for (var diagnostics_1 = __values(diagnostics), diagnostics_1_1 = diagnostics_1.next(); !diagnostics_1_1.done; diagnostics_1_1 = diagnostics_1.next()) {
                                            var d = diagnostics_1_1.value;
                                            var d_ = __assign({}, c2pConverter.asDiagnostic(d));
                                            diagnostics_.push(d_);
                                        }
                                    }
                                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                    finally {
                                        try {
                                            if (diagnostics_1_1 && !diagnostics_1_1.done && (_a = diagnostics_1.return)) _a.call(diagnostics_1);
                                        }
                                        finally { if (e_1) throw e_1.error; }
                                    }
                                    _this.diagnosticsEmitter.fire({ uri: uri_, diagnostics: diagnostics_ });
                                },
                                // didOpen: async () => {
                                //   // Note: as per the LSP spec: An open notification must not be sent more than once
                                //   // without a corresponding close notification send before. This means open and close
                                //   // notification must be balanced and the max open count for a particular textDocument
                                //   // is one.  So this even does nothing the notification is handled by the
                                //   // openLean4Document method below after the 'lean4' languageId is established and
                                //   // it has weeded out documents opened to invisible editors (like 'git:' schemes and
                                //   // invisible editors created for Ctrl+Hover events.  A side effect of unbalanced
                                //   // open/close notification is leaking 'lean --worker' processes.
                                //   // See https://github.com/microsoft/vscode/issues/78453).
                                // },
                                didChange: function (data, next) { return __awaiter(_this, void 0, void 0, function () {
                                    var params;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, next(data)];
                                            case 1:
                                                _a.sent();
                                                if (!this.running || (this.client == null))
                                                    return [2 /*return*/]; // there was a problem starting lean server.
                                                params = c2pConverter.asChangeTextDocumentParams(data);
                                                this.didChangeEmitter.fire(params);
                                                return [2 /*return*/];
                                        }
                                    });
                                }); },
                                didClose: function (doc, next) { return __awaiter(_this, void 0, void 0, function () {
                                    var params;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (!this.isOpen.delete(doc.uri.toString())) {
                                                    return [2 /*return*/];
                                                }
                                                return [4 /*yield*/, next(doc)];
                                            case 1:
                                                _a.sent();
                                                if (!this.running || (this.client == null))
                                                    return [2 /*return*/]; // there was a problem starting lean server.
                                                params = c2pConverter.asCloseTextDocumentParams(doc);
                                                this.didCloseEmitter.fire(params);
                                                return [2 /*return*/];
                                        }
                                    });
                                }); },
                                provideDocumentHighlights: function (doc, pos, ctok, next) { return __awaiter(_this, void 0, void 0, function () {
                                    var leanHighlights, wordRange, word, highlights, text, nonWordPattern, regexp, _a, _b, match, start;
                                    var e_2, _c;
                                    var _d;
                                    return __generator(this, function (_e) {
                                        switch (_e.label) {
                                            case 0: return [4 /*yield*/, next(doc, pos, ctok)];
                                            case 1:
                                                leanHighlights = _e.sent();
                                                if (leanHighlights === null || leanHighlights === void 0 ? void 0 : leanHighlights.length)
                                                    return [2 /*return*/, leanHighlights
                                                        // vscode doesn't fall back to textual highlights,
                                                        // so we need to do that manually
                                                    ];
                                                // vscode doesn't fall back to textual highlights,
                                                // so we need to do that manually
                                                return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, 250); })];
                                            case 2:
                                                // vscode doesn't fall back to textual highlights,
                                                // so we need to do that manually
                                                _e.sent();
                                                if (ctok.isCancellationRequested)
                                                    return [2 /*return*/];
                                                wordRange = doc.getWordRangeAtPosition(pos);
                                                if (wordRange == null)
                                                    return [2 /*return*/];
                                                word = doc.getText(wordRange);
                                                highlights = [];
                                                text = doc.getText();
                                                nonWordPattern = '[`~@$%^&*()-=+\\[{\\]}⟨⟩⦃⦄⟦⟧⟮⟯‹›\\\\|;:\",./\\s]|^|$';
                                                regexp = new RegExp("(?<=".concat(nonWordPattern, ")").concat(escapeRegExp(word), "(?=").concat(nonWordPattern, ")"), 'g');
                                                try {
                                                    for (_a = __values(text.matchAll(regexp)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                                        match = _b.value;
                                                        start = doc.positionAt((_d = match.index) !== null && _d !== void 0 ? _d : 0);
                                                        highlights.push({
                                                            range: new Range(start, start.translate(0, match[0].length)),
                                                            kind: DocumentHighlightKind.Text
                                                        });
                                                    }
                                                }
                                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                                finally {
                                                    try {
                                                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                                    }
                                                    finally { if (e_2) throw e_2.error; }
                                                }
                                                return [2 /*return*/, highlights];
                                        }
                                    });
                                }); }
                            }
                        };
                        if (!!this.client) return [3 /*break*/, 3];
                        this.client = new LanguageClient({
                            id: 'lean4',
                            name: 'Lean 4',
                            clientOptions: clientOptions,
                            connectionProvider: {
                                get: function () { return __awaiter(_this, void 0, void 0, function () {
                                    var _this = this;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                                                    console.log("connecting ".concat(_this.socketUrl));
                                                    var websocket = new WebSocket(_this.socketUrl);
                                                    websocket.addEventListener('error', function (ev) {
                                                        reject(ev);
                                                    });
                                                    websocket.addEventListener('message', function (msg) {
                                                        // console.log(msg.data)
                                                    });
                                                    websocket.addEventListener('open', function () {
                                                        var socket = toSocket(websocket);
                                                        var reader = new WebSocketMessageReader(socket);
                                                        var writer = new WebSocketMessageWriter(socket);
                                                        resolve({
                                                            reader: reader,
                                                            writer: writer
                                                        });
                                                    });
                                                })];
                                            case 1: return [2 /*return*/, _a.sent()];
                                        }
                                    });
                                }); }
                            }
                        });
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.client.start()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        // HACK: Prevent monaco from panicking when the Lean server crashes
                        this.client.handleFailedRequest = function (type, token, error, defaultValue, showNotification) {
                            return defaultValue;
                        };
                        insideRestart = true;
                        patchConverters(this.client.protocol2CodeConverter, this.client.code2ProtocolConverter);
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        this.client.onDidChangeState(function (s) { return __awaiter(_this, void 0, void 0, function () {
                            var end;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(s.newState === State.Starting)) return [3 /*break*/, 1];
                                        console.log('[LeanClient] starting');
                                        return [3 /*break*/, 4];
                                    case 1:
                                        if (!(s.newState === State.Running)) return [3 /*break*/, 2];
                                        end = Date.now();
                                        console.log("[LeanClient] running, started in ".concat(end - startTime, " ms"));
                                        this.running = true; // may have been auto restarted after it failed.
                                        if (!insideRestart) {
                                            this.restartedEmitter.fire(undefined);
                                        }
                                        return [3 /*break*/, 4];
                                    case 2:
                                        if (!(s.newState === State.Stopped)) return [3 /*break*/, 4];
                                        this.running = false;
                                        console.log('[LeanClient] has stopped or it failed to start');
                                        if (!!this.noPrompt) return [3 /*break*/, 4];
                                        // only raise this event and show the message if we are not the ones
                                        // who called the stop() method.
                                        this.stoppedEmitter.fire({ message: 'Lean server has stopped.', reason: '' });
                                        return [4 /*yield*/, this.showRestartMessage()];
                                    case 3:
                                        _a.sent();
                                        _a.label = 4;
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, this.client.start()
                            // tell the new client about the documents that are already open!
                            // for (const key of this.isOpen.keys()) {
                            //   const doc = this.isOpen.get(key)
                            //   if (doc != null) this.notifyDidOpen(doc)
                            // }
                            // if we got this far then the client is happy so we are running!
                        ];
                    case 7:
                        _a.sent();
                        // tell the new client about the documents that are already open!
                        // for (const key of this.isOpen.keys()) {
                        //   const doc = this.isOpen.get(key)
                        //   if (doc != null) this.notifyDidOpen(doc)
                        // }
                        // if we got this far then the client is happy so we are running!
                        this.running = true;
                        return [3 /*break*/, 9];
                    case 8:
                        error_1 = _a.sent();
                        console.log(error_1);
                        this.serverFailedEmitter.fire('' + error_1);
                        insideRestart = false;
                        return [2 /*return*/];
                    case 9:
                        starHandler = function (method, params_) {
                            if (method === '$/lean/fileProgress' && (_this.client != null)) {
                                var params = params_;
                                var uri = p2cConverter.asUri(params.textDocument.uri);
                                _this.progressChangedEmitter.fire([uri.toString(), params.processing]);
                                // save the latest progress on this Uri in case infoview needs it later.
                                _this.progress.set(uri, params.processing);
                            }
                            _this.customNotificationEmitter.fire({ method: method, params: params_ });
                        };
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                        this.client.onNotification(starHandler, function () { });
                        // Reveal the standard error output channel when the server prints something to stderr.
                        // The vscode-languageclient library already takes care of writing it to the output channel.
                        // let stderrMsgBoxVisible = false;
                        // (this.client)._serverProcess.stderr.on('data', async (chunk: Buffer) => {
                        //   if (shouldAutofocusOutput()) {
                        //     this.client?.outputChannel.show(true)
                        //   } else if (!stderrMsgBoxVisible) {
                        //     stderrMsgBoxVisible = true
                        //     const outputItem = 'Show stderr output'
                        //     const outPrompt = `Lean server printed an error:\n${chunk.toString()}`
                        //     if (await window.showErrorMessage(outPrompt, outputItem) === outputItem) {
                        //       this.outputChannel.show(false)
                        //     }
                        //     stderrMsgBoxVisible = false
                        //   }
                        // })
                        this.restartedEmitter.fire(undefined);
                        insideRestart = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    LeanClient.prototype.openLean4Document = function (doc) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isOpen.has(doc.uri.toString()))
                            return [2 /*return*/];
                        return [4 /*yield*/, this.isSameWorkspace(doc.uri)];
                    case 1:
                        if (!(_a.sent())) {
                            // skip it, this file belongs to a different workspace...
                            return [2 /*return*/];
                        }
                        this.isOpen.set(doc.uri.toString(), doc);
                        if (!this.running)
                            return [2 /*return*/]; // there was a problem starting lean server.
                        // didOpenEditor may have also changed the language, so we fire the
                        // event here because the InfoView should be wired up to receive it now.
                        this.didSetLanguageEmitter.fire(doc.languageId);
                        this.notifyDidOpen(doc);
                        return [2 /*return*/];
                }
            });
        });
    };
    LeanClient.prototype.notifyDidOpen = function (doc) {
        var _a;
        void ((_a = this.client) === null || _a === void 0 ? void 0 : _a.sendNotification(DidOpenTextDocumentNotification.type, {
            textDocument: {
                uri: doc.uri.toString(),
                languageId: doc.languageId,
                version: 1,
                text: doc.getText()
            }
        }));
    };
    LeanClient.prototype.isSameWorkspace = function (uri) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // if (this.folderUri) {
                //   if (this.folderUri.scheme !== uri.scheme) return false
                //   if (this.folderUri.scheme === 'file') {
                //     const realPath1 = await fs.promises.realpath(this.folderUri.fsPath)
                //     const realPath2 = await fs.promises.realpath(uri.fsPath)
                //     return isFileInFolder(realPath2, realPath1)
                //   } else {
                //     return uri.toString().startsWith(this.folderUri.toString())
                //   }
                // } else {
                //   return uri.scheme === 'untitled'
                // }
                return [2 /*return*/, false];
            });
        });
    };
    LeanClient.prototype.getWorkspaceFolder = function () {
        var _a;
        return (_a = this.folderUri) === null || _a === void 0 ? void 0 : _a.toString();
    };
    LeanClient.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.restart()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LeanClient.prototype.isStarted = function () {
        return this.client !== undefined;
    };
    LeanClient.prototype.isRunning = function () {
        if (this.client != null) {
            return this.running;
        }
        return false;
    };
    LeanClient.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!((this.client != null) && this.running)) return [3 /*break*/, 4];
                        this.noPrompt = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        // some timing conditions can happen while running unit tests that cause
                        // this to throw an exception which then causes those tests to fail.
                        return [4 /*yield*/, this.client.stop()];
                    case 2:
                        // some timing conditions can happen while running unit tests that cause
                        // this to throw an exception which then causes those tests to fail.
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        console.log("[LeanClient] Error stopping language client: ".concat(e_3));
                        return [3 /*break*/, 4];
                    case 4:
                        this.noPrompt = false;
                        this.progress = new Map();
                        this.client = undefined;
                        this.running = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    LeanClient.prototype.configChanged = function (e) {
        // let newToolchainPath = this.storageManager.getLeanPath()
        // if (!newToolchainPath) newToolchainPath = toolchainPath()
        // if (this.toolchainPath !== newToolchainPath) {
        //  void this.restart()
        // }
    };
    LeanClient.prototype.restartFile = function (doc) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var uri;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.running)
                            return [2 /*return*/]; // there was a problem starting lean server.
                        return [4 /*yield*/, this.isSameWorkspace(doc.uri)];
                    case 1:
                        // assert(() => this.isStarted())
                        if (!(_c.sent())) {
                            // skip it, this file belongs to a different workspace...
                            return [2 /*return*/];
                        }
                        uri = doc.uri.toString();
                        console.log("[LeanClient] Restarting File: ".concat(uri));
                        // This causes a text document version number discontinuity. In
                        // (didChange (oldVersion) => restartFile => didChange (newVersion))
                        // the client emits newVersion = oldVersion + 1, despite the fact that the
                        // didOpen packet emitted below initializes the version number to be 1.
                        // This is not a problem though, since both client and server are fine
                        // as long as the version numbers are monotonous.
                        void ((_a = this.client) === null || _a === void 0 ? void 0 : _a.sendNotification('textDocument/didClose', {
                            textDocument: {
                                uri: uri
                            }
                        }));
                        void ((_b = this.client) === null || _b === void 0 ? void 0 : _b.sendNotification('textDocument/didOpen', {
                            textDocument: {
                                uri: uri,
                                languageId: 'lean4',
                                version: 1,
                                text: doc.getText()
                            }
                        }));
                        this.restartedWorkerEmitter.fire(uri);
                        return [2 /*return*/];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    LeanClient.prototype.sendRequest = function (method, params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.running && (this.client != null))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.client.sendRequest(method, params)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, new Promise(function (_, reject) { reject('Client is not running'); })];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/, _a];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    LeanClient.prototype.sendNotification = function (method, params) {
        return this.running && (this.client != null) ? this.client.sendNotification(method, params) : undefined;
    };
    LeanClient.prototype.getDiagnosticParams = function (uri, diagnostics) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = {
                            uri: c2pConverter.asUri(uri)
                        };
                        return [4 /*yield*/, c2pConverter.asDiagnostics(diagnostics)];
                    case 1:
                        params = (_a.diagnostics = _b.sent(),
                            _a);
                        return [2 /*return*/, params];
                }
            });
        });
    };
    LeanClient.prototype.getDiagnostics = function () {
        var _a;
        return this.running ? (_a = this.client) === null || _a === void 0 ? void 0 : _a.diagnostics : undefined;
    };
    Object.defineProperty(LeanClient.prototype, "initializeResult", {
        get: function () {
            var _a;
            return this.running ? (_a = this.client) === null || _a === void 0 ? void 0 : _a.initializeResult : undefined;
        },
        enumerable: false,
        configurable: true
    });
    LeanClient.prototype.checkToolchainVersion = function (folderUri) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // see if we have a well known toolchain label that corresponds
                // to a known date like 'leanprover/lean4:nightly-2022-02-01'
                // const toolchainVersion = await readLeanVersion(folderUri)
                // if (toolchainVersion) {
                //   const match = /^leanprover\/lean4:nightly-(\d+)-(\d+)-(\d+)$/.exec(toolchainVersion)
                //   if (match != null) {
                //     return new Date(parseInt(match[1]), parseInt(match[2]) - 1, parseInt(match[3]))
                //   }
                //   if (toolchainVersion === 'leanprover/lean4:stable') {
                //     return new Date(2022, 2, 1)
                //   }
                // }
                return [2 /*return*/, undefined];
            });
        });
    };
    // async checkLakeVersion (executable: string, version: string): Promise<boolean> {
    //   // Check that the Lake version is high enough to support "lake serve" option.
    //   const versionOptions = version ? ['+' + version, '--version'] : ['--version']
    //   const start = Date.now()
    //   const lakeVersion = await batchExecute(executable, versionOptions, this.folderUri?.fsPath, undefined)
    //   logger.log(`[LeanClient] Ran '${executable} ${versionOptions.join(' ')}' in ${Date.now() - start} ms`)
    //   const actual = this.extractVersion(lakeVersion)
    //   if (actual.compare('3.0.0') > 0) {
    //     return true
    //   }
    //   return false
    // }
    LeanClient.prototype.extractVersion = function (v) {
        if (!v)
            return new SemVer('0.0.0');
        var prefix = 'Lake version';
        if (v.startsWith(prefix))
            v = v.slice(prefix.length).trim();
        var pos = v.indexOf('(');
        if (pos > 0)
            v = v.slice(0, pos).trim();
        try {
            return new SemVer(v);
        }
        catch (_a) {
            return new SemVer('0.0.0');
        }
    };
    return LeanClient;
}());
export { LeanClient };
